import { get, post, put, del } from "services/httpService";

const SERVICE_URLS = {
  getProfile: () => "user/detail/",
  updateProfile: () => "user/detail/",
  getBillingHistory: () => `user/billing-history/`,
  changePassword: () => "user/change-password/",
  uploadUserIcon: () => "user-icon/",
  purchasePlan: () => "user/plan-subscription/",
  getCardDetails: () => "user/payment-details/",
  updateCardDetails: () => "subscription/update-payment-method/",
  cancelPlan: () => "user/cancel-subscription/",
  change2FA: () => `user/mfa/`,
  sendStepUpCode: () => "user/withdrawal-mfa/send/",
  verifyStepUpCode: () => "user/withdrawal-mfa/verify/",
  verifyPhone: () => "user/verify/",
  updatePhone: () => `user/phone/`,
  resendVerification: () => "user/send-mfa/",
  updateAndverifyPhone: () => "user/phone/",
  getPlanRevision: () => "dynamic-json-schema/?type=PLAN_REVISION",
  getPartnerships: (userId) => `partnerships/user/${userId}/status/`,
  connectPartnership: (userId, partnershipType) =>
    `partnerships/user/${userId}/connect/${partnershipType}/`,
  activityLogs: () => `user/activity-logs/`,
  strategiesFromLogs: () =>
    `user/activity-logs/?action=invest_strategy_selected&size=1`,
  fundsFromLogs: () => `user/activity-logs/?action=fund_account_requested`,
  questionnaire: () => `/questionnaire/`,
  checkAlpacaAccountStatus: () => `/internal-account/alpaca/status/`,
  uploadAccountDocument: () => `/internal-account/alpaca/documents/`,
};

export const getPlanRevision = () => get(SERVICE_URLS.getPlanRevision());

export const getProfile = () => get(SERVICE_URLS.getProfile());
export const getQuestionnaire = () => get(SERVICE_URLS.questionnaire());
export const getBillingHistory = (params) =>
  get(SERVICE_URLS.getBillingHistory(), params);

export const changePassword = (payload) =>
  post(SERVICE_URLS.changePassword(), payload);

export const updateProfile = (payload) =>
  put(SERVICE_URLS.updateProfile(), payload);

export const uploadUserIcon = (payload) =>
  post(SERVICE_URLS.uploadUserIcon(), payload);

export const purchasePlan = (data) => {
  let payload = {};

  if (data?.id) {
    payload.token = data.id;
  }

  if (data?.card_id) {
    payload.card_id = data.card_id;
  }

  return post(SERVICE_URLS.purchasePlan(), payload);
};

export const getCardDetails = (payload) =>
  get(SERVICE_URLS.getCardDetails(), payload);

export const updateCardDetails = (token) => {
  const payload = { token: token.id };
  return post(SERVICE_URLS.updateCardDetails(), payload);
};

export const cancelPlan = (payload) => del(SERVICE_URLS.cancelPlan(), payload);

export const change2FA = (payload) => post(SERVICE_URLS.change2FA(), payload);

// Step-up verification: prove the second factor again before a high-risk
// action. Returns a single-use token, bound to the action, that the caller
// sends along with the action itself.
export const sendStepUpCode = (payload) =>
  post(SERVICE_URLS.sendStepUpCode(), payload);

export const verifyStepUpCode = (payload) =>
  post(SERVICE_URLS.verifyStepUpCode(), payload);

export const updatePhone = (payload) =>
  post(SERVICE_URLS.updatePhone(), payload);

export const verifyPhone = (payload) =>
  post(SERVICE_URLS.verifyPhone(), payload);

export const resendVerification = (payload) =>
  post(SERVICE_URLS.resendVerification(), payload);

export const updateAndverifyPhone = (payload) =>
  put(SERVICE_URLS.updateAndverifyPhone(), payload);

export const getPartnershipStatus = (userId, partnershipId) =>
  get(SERVICE_URLS.getPartnershipStatus(userId, partnershipId));

export const createPartnership = (userId, partnershipId, payload) =>
  post(SERVICE_URLS.createPartnership(userId, partnershipId), payload);

export const getPartnerships = (userId) =>
  get(SERVICE_URLS.getPartnerships(userId));

export const connectPartnership = (userId, partnershipType, code) =>
  post(SERVICE_URLS.connectPartnership(userId, partnershipType), { code });

export const activityLogs = (payload) =>
  put(SERVICE_URLS.activityLogs(), payload);

export const getActivityLogs = (params) =>
  get(SERVICE_URLS.activityLogs(), params);

export const getStrategiesfromLogs = (params) =>
  get(SERVICE_URLS.strategiesFromLogs(), params);

export const getAvailableFundsfromLogs = (params) =>
  get(SERVICE_URLS.fundsFromLogs(), params);

export const checkAlpacaAccountStatus = () =>
  get(SERVICE_URLS.checkAlpacaAccountStatus());

export const uploadAccountDocument = (payload) =>
  post(SERVICE_URLS.uploadAccountDocument(), payload, {
    includeStatus: true,
  });
